'use strict';

(function () {
  'use strict';

  angular.module('youth').config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('home', {
      url: '/',
      views: {
        '': {
          templateUrl: 'youth/pages/home.html',
          controller: 'HomeCtrl',
          controllerAs: 'vm',
          resolve: {
            'session': ['historySvc', function (historySvc) {
              return historySvc.getCurrent();
            }]
          }
        },
        'hero@home': {
          templateUrl: 'youth/templates/home/hero.html',
          controller: 'HomeHeroCtrl',
          controllerAs: 'hero'
        },
        'quote@home': {
          templateUrl: 'youth/templates/home/quote.html',
          controller: 'QuoteCtrl',
          controllerAs: 'quoteCtrl',
          resolve: {
            quote: ['quoteSvc', function (quoteSvc) {
              return quoteSvc.getRandomQuote();
            }]
          }
        },
        'slider@home': {
          templateUrl: 'youth/templates/home/slider.html',
          controller: 'HomeSliderCtrl',
          controllerAs: 'slider'
        },
        'discussion@home': {
          templateUrl: 'youth/templates/home/discussion.html',
          controller: 'HomeDiscussionCtrl'
        }
      },
      data: {
        pageTitle: 'pageTitles.home'
      },
      resolve: {
        activities: ['activitySvc', function (activitySvc) {
          return activitySvc.getHomeActivities('youth');
        }]
      }
    }).state('library', {
      url: '/library',
      templateUrl: 'youth/pages/library.html',
      controller: 'LibraryCtrl',
      controllerAs: 'vm',
      resolve: {
        'savedActivities': ['librarySvc', function (librarySvc) {
          return librarySvc.get(true);
        }]
      },
      data: {
        pageTitle: 'pageTitles.library'
      }
    }).state('tracker', {
      url: '/tracker',
      templateUrl: 'youth/pages/tracker.html',
      controller: 'TrackerCtrl',
      controllerAs: 'tracker',
      resolve: {
        'daily': ['historySvc', function (historySvc) {
          return historySvc.getRecent();
        }]
      },
      data: {
        pageTitle: 'pageTitles.tracker'
      }
    }).state('help', {
      url: '/help',
      templateUrl: 'youth/pages/get-help.html',
      controller: 'YouthGetHelpCtrl',
      controllerAs: 'vm',
      data: {
        pageTitle: 'pageTitles.help'
      }
    }).state('logout', {
      url: '/logout',
      template: '',
      controller: 'logoutCtrl',
      controllerAs: 'vm',
      data: {
        pageTitle: 'pageTitles.logout'
      }
    });
  }]);
})();